require("!!/root/workspace/jimujia-pc_4ez23/wwwroot/static/node_modules/script-loader/addScript.js")(require("!!/root/workspace/jimujia-pc_4ez23/wwwroot/static/node_modules/raw-loader/index.js!/root/workspace/jimujia-pc_4ez23/wwwroot/static/plugins/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js"))


/*****************
 ** WEBPACK FOOTER
 ** /root/workspace/jimujia-pc_4ez23/wwwroot/static/~/script-loader!/root/workspace/jimujia-pc_4ez23/wwwroot/static/plugins/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js
 ** module id = 192
 ** module chunks = 1
 **/